// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TGPUvmBWpIbzQW {
  margin-top: var(--ds-space-100, 8px);
  margin-bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var unsubscribeConfirmButton = `TGPUvmBWpIbzQW`;
export default ___CSS_LOADER_EXPORT___;
